import { SortableContainer, SortableElement } from 'react-sortable-hoc';

export const SortableList = SortableContainer(({ children }) => {
    return children;
});

export const SortableItem = SortableElement(({ children }) => {
    return children;
});